export enum TrailerLabel {
  Hold = 'HOLD',
  Closed = 'CLOSED'
}
